module.exports = __webpack_public_path__ + "img/22.5b4f4146.png";